import './AdPreviewModal.scss';

import { faComment, faHeart, faShare, faTimes } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'react-bootstrap';
import { formatInReal } from '../../../../commons/util/HallAppUtil';

function AdPreviewModal({ show, closeModal, adData, imageFile }) {
    const formatDate = () => {
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const getCallToActionText = () => {
        if (adData.destinationUrl?.includes('wa.me')) {
            return 'Conversar no WhatsApp';
        }
        return 'Saiba mais';
    };

    const getObjectiveName = () => {
        const objectives = {
            'LINK_CLICKS': 'Tráfego (cliques no link)',
            'REACH': 'Alcance',
            'BRAND_AWARENESS': 'Reconhecimento da marca',
        };
        return objectives[adData.objective] || adData.objective || 'Não definido';
    };

    const getGenderName = () => {
        const genders = {
            'male': '👨 Homens',
            'female': '👩 Mulheres',
            'all': '👥 Todos'
        };
        return genders[adData.targetGender] || '👥 Todos';
    };

    const formatBudget = (value) => {
        // Se o valor já está em centavos (ex: 6000 = R$ 60,00)
        const realValue = (value || 0) / 100;
        return realValue.toLocaleString('pt-BR', { 
            style: 'currency', 
            currency: 'BRL' 
        });
    };

    return (
        <Modal 
            show={show} 
            onHide={closeModal} 
            size="lg" 
            centered
            className="ad-preview-modal"
        >
            <Modal.Header style={{ 
                borderBottom: '1px solid #e9ecef',
                padding: '16px 20px',
                background: '#f8f9fa'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flex: 1 }}>
                    <span style={{ fontSize: '24px' }}>👁️</span>
                    <div>
                        <h5 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
                            Visualização do Anúncio
                        </h5>
                        <small style={{ color: '#5a6c7d' }}>
                            Veja como seu anúncio aparecerá no Facebook e Instagram
                        </small>
                    </div>
                </div>
                <button
                    onClick={closeModal}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: '24px',
                        cursor: 'pointer',
                        color: '#5a6c7d',
                        padding: '0',
                        marginLeft: '12px'
                    }}
                >
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </Modal.Header>

            <Modal.Body style={{ padding: '24px', background: '#f0f2f5' }}>
                <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                    {/* Preview Instagram */}
                    <div style={{ flex: '1 1 300px', minWidth: '300px' }}>
                        <h6 style={{ 
                            fontSize: '14px', 
                            fontWeight: 600, 
                            color: '#5a6c7d',
                            marginBottom: '12px',
                            textAlign: 'center'
                        }}>
                            📱 Instagram Feed
                        </h6>
                        <div className="instagram-preview">
                            {/* Header do post */}
                            <div className="preview-header">
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}>
                                        H
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 600, fontSize: '14px' }}>
                                            hallappbrasil
                                        </div>
                                        <div style={{ fontSize: '11px', color: '#8e8e8e' }}>
                                            Patrocinado
                                        </div>
                                    </div>
                                </div>
                                <div style={{ fontSize: '20px', cursor: 'pointer' }}>⋯</div>
                            </div>

                            {/* Imagem */}
                            <div className="preview-image">
                                {imageFile ? (
                                    <img 
                                        src={URL.createObjectURL(imageFile)} 
                                        alt="Preview"
                                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                ) : (
                                    <div style={{
                                        width: '100%',
                                        height: '100%',
                                        background: '#e9ecef',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: '#5a6c7d',
                                        flexDirection: 'column',
                                        gap: '8px'
                                    }}>
                                        <span style={{ fontSize: '48px' }}>📷</span>
                                        <span>Adicione uma imagem</span>
                                    </div>
                                )}
                            </div>

                            {/* Ações */}
                            <div className="preview-actions">
                                <div style={{ display: 'flex', gap: '16px' }}>
                                    <FontAwesomeIcon icon={faHeart} style={{ fontSize: '24px', cursor: 'pointer' }} />
                                    <FontAwesomeIcon icon={faComment} style={{ fontSize: '24px', cursor: 'pointer' }} />
                                    <FontAwesomeIcon icon={faShare} style={{ fontSize: '24px', cursor: 'pointer' }} />
                                </div>
                            </div>

                            {/* Texto */}
                            <div className="preview-text">
                                <div style={{ marginBottom: '8px' }}>
                                    <strong>hallappbrasil</strong>{' '}
                                    <span style={{ color: '#262626' }}>
                                        {adData.primaryText || 'Seu texto principal aparecerá aqui...'}
                                    </span>
                                </div>
                                <div style={{ color: '#8e8e8e', fontSize: '12px' }}>
                                    {formatDate()}
                                </div>
                            </div>

                            {/* CTA Button */}
                            {adData.destinationUrl && (
                                <div style={{ padding: '0 12px 12px' }}>
                                    <button className="preview-cta-button instagram-cta">
                                        {getCallToActionText()}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Preview Facebook */}
                    <div style={{ flex: '1 1 300px', minWidth: '300px' }}>
                        <h6 style={{ 
                            fontSize: '14px', 
                            fontWeight: 600, 
                            color: '#5a6c7d',
                            marginBottom: '12px',
                            textAlign: 'center'
                        }}>
                            📘 Facebook Feed
                        </h6>
                        <div className="facebook-preview">
                            {/* Header do post */}
                            <div className="preview-header">
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <div style={{
                                        width: '40px',
                                        height: '40px',
                                        borderRadius: '50%',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        fontSize: '16px'
                                    }}>
                                        H
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 600, fontSize: '15px' }}>
                                            HallApp
                                        </div>
                                        <div style={{ fontSize: '13px', color: '#65676b' }}>
                                            Patrocinado · 🌎
                                        </div>
                                    </div>
                                </div>
                                <div style={{ fontSize: '20px', cursor: 'pointer', color: '#65676b' }}>⋯</div>
                            </div>

                            {/* Texto principal */}
                            <div className="preview-text" style={{ padding: '12px 16px' }}>
                                <span style={{ color: '#050505', fontSize: '15px', lineHeight: '1.3333' }}>
                                    {adData.primaryText || 'Seu texto principal aparecerá aqui...'}
                                </span>
                            </div>

                            {/* Card do link */}
                            <div className="preview-link-card">
                                {/* Imagem */}
                                <div style={{ 
                                    width: '100%', 
                                    height: '300px',
                                    background: '#e9ecef',
                                    position: 'relative'
                                }}>
                                    {imageFile ? (
                                        <img 
                                            src={URL.createObjectURL(imageFile)} 
                                            alt="Preview"
                                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <div style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#5a6c7d',
                                            flexDirection: 'column',
                                            gap: '8px'
                                        }}>
                                            <span style={{ fontSize: '48px' }}>📷</span>
                                            <span>Adicione uma imagem</span>
                                        </div>
                                    )}
                                </div>

                                {/* Info do link */}
                                <div style={{ 
                                    padding: '12px',
                                    background: '#f0f2f5',
                                    borderTop: '1px solid #dddfe2'
                                }}>
                                    <div style={{ 
                                        fontSize: '12px', 
                                        color: '#65676b',
                                        textTransform: 'uppercase',
                                        marginBottom: '4px'
                                    }}>
                                        {adData.destinationUrl ? new URL(adData.destinationUrl).hostname.toUpperCase() : 'SEU-SITE.COM.BR'}
                                    </div>
                                    <div style={{ 
                                        fontSize: '16px', 
                                        fontWeight: 600,
                                        color: '#050505',
                                        marginBottom: '4px',
                                        lineHeight: '1.2'
                                    }}>
                                        {adData.headline || 'Seu título aparecerá aqui'}
                                    </div>
                                </div>

                                {/* CTA Button */}
                                {adData.destinationUrl && (
                                    <div style={{ 
                                        padding: '8px 12px',
                                        background: '#f0f2f5',
                                        borderTop: '1px solid #dddfe2'
                                    }}>
                                        <button className="preview-cta-button facebook-cta">
                                            {getCallToActionText()}
                                        </button>
                                    </div>
                                )}
                            </div>

                            {/* Ações */}
                            <div className="preview-actions" style={{ 
                                padding: '8px 16px',
                                borderTop: '1px solid #dddfe2',
                                display: 'flex',
                                justifyContent: 'space-around'
                            }}>
                                <button style={{ 
                                    background: 'none',
                                    border: 'none',
                                    color: '#65676b',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    padding: '8px 12px'
                                }}>
                                    👍 Curtir
                                </button>
                                <button style={{ 
                                    background: 'none',
                                    border: 'none',
                                    color: '#65676b',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    padding: '8px 12px'
                                }}>
                                    💬 Comentar
                                </button>
                                <button style={{ 
                                    background: 'none',
                                    border: 'none',
                                    color: '#65676b',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    padding: '8px 12px'
                                }}>
                                    ↗️ Compartilhar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Informações adicionais */}
                <div style={{
                    marginTop: '24px',
                    padding: '16px',
                    background: 'white',
                    borderRadius: '10px',
                    border: '1px solid #e9ecef'
                }}>
                    <h6 style={{ fontSize: '14px', fontWeight: 600, marginBottom: '12px' }}>
                        ℹ️ Informações do Anúncio
                    </h6>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px', fontSize: '14px' }}>
                        <div>
                            <strong>Objetivo:</strong> {getObjectiveName()}
                        </div>
                        <div>
                            <strong>Orçamento diário:</strong> {formatInReal(adData.dailyBudget)}
                        </div>
                        <div>
                            <strong>Faixa etária:</strong> {adData.ageMin || 18} - {adData.ageMax || 65} anos
                        </div>
                        <div>
                            <strong>Gênero:</strong> {getGenderName()}
                        </div>
                        <div>
                            <strong>Localização:</strong> {adData.locationTarget || 'Não definida'}
                        </div>
                        <div>
                            <strong>Link:</strong> {adData.destinationUrl ? '✅ Configurado' : '❌ Não configurado'}
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer style={{ 
                borderTop: '1px solid #e9ecef',
                padding: '16px 20px',
                background: '#f8f9fa'
            }}>
                <button
                    onClick={closeModal}
                    style={{
                        padding: '12px 24px',
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        fontSize: '15px'
                    }}
                >
                    Fechar Visualização
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default AdPreviewModal;